import { useHeaderSettingsStore } from '@/Features/App/Components/store';
import { UserCircleIcon } from '@heroicons/react/24/solid';
import { inject, observer } from 'mobx-react';
import { useMemo, useState } from 'react';
import UserSettingsMenu from './UserSettingsMenu';

const UserSettings = ({ store }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  console.log(anchorEl);

  const fromColor = useMemo(() => {
    if (store.profile.credits <= 0) {
      return 'bg-red-200 text-red-600';
    }
    if (store.profile.status === 'trialing') {
      return '';
    }
    if (store.profile.status === 'active') {
      return '';
    }
    if (store.profile.status === 'incomplete') {
      return '';
    }
    return 'bg-red-200 text-red-600';
  }, [store.profile.credits, store.profile.status]);

  const avatar = useMemo(() => {
    if (store.profile.avatar?.svg) {
      return store.profile.avatar.svg;
    }
    return null;
  }, [store.profile.avatar?.svg]);

  return (
    <>
      <div
        id="user-settings-button"
        onClick={handleClick}
        className={`flex px-1 cursor-pointer ${fromColor} hover:bg-platinum rounded-md transition items-center dark:hover:bg-night-black max-md:hidden`}
      >
        {avatar ? (
          <div className="avatar">
            <div className="w-10 rounded">
              <div
                dangerouslySetInnerHTML={{
                  __html: avatar,
                }}
              />
            </div>
          </div>
        ) : (
          <UserCircleIcon className="size-9 transition -mb-1 text-cool-gray dark:text-battleship-gray cursor-pointer" />
        )}
      </div>
      <UserSettingsMenu
        anchorEl={anchorEl}
        open={open}
        handleClose={handleClose}
      />
    </>
  );
};

export default inject('store')(observer(UserSettings));
